import { action } from 'easy-peasy';
import { IActionSetPrograms } from '../types';

const setPrograms: IActionSetPrograms = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.length;

  state.items = payload;
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setPrograms;
